import { useState } from "react";
import { Lists } from "../../components/common/Lists";
import { useGetPlanSubjectsQuery } from "../../hooks/useGetPlanSubjectsQuery";
import TableComponent from "../../components/common/Tables";
import { Badge } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";
import { DeletePlanSubjectType, PlanSubjectType } from "../../types/PlanSubject";
import { TrashIcon } from "@radix-ui/react-icons";
import { useAppDispatch } from "../../hooks/hooks";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { deletePlanSubject } from "../../services/school/PlanSubjects";
import { setUpdatePlanSubjectData } from "../../redux/slices/school/planSubject";

const columnNamesMap: { [key: string]: string } = {
    course: 'Curso',
    academicYear: 'Ano académico',
    subject: 'Disciplina',
    level: 'Ano',
    semester: 'Semestre',
    isCoreBadge: 'Nuclear/Opcional', 
    hasExameBadge: 'Tem exame?', 
};

export const PlanSubjects = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();

    const { data, status } = useGetPlanSubjectsQuery({ PageNumber: currentPage, PageSize: 400 });
    const mutationDeletePlanSubject = useMutation(deletePlanSubject, {
        onSuccess: () => {
            queryClient.invalidateQueries('plan-subjects-pagination');
            toast.success('Disciplina apagada do plano de curso');
        },
        onError: () => {
            toast.error('Erro ao apagar disciplina do plano de curso') 
        }
    })

    const handlePageChange = (page:number)=>{
        setCurrentPage(page);
    }

    const handleClickCreate = (event:any):void =>{
        navigate(routes.createUpdatePlanSubjects);
    }

    const handleDelete = (planSubject: PlanSubjectType)=>{
        var deletePlanSubject: DeletePlanSubjectType = {
            idPlan: planSubject.idPlan,
            subjects: [planSubject.idSubject],
            id: planSubject.idPlan
        } 
        mutationDeletePlanSubject.mutateAsync(deletePlanSubject);
    }

    const handleAddSubjectPlan = (planSubject: PlanSubjectType) => {
        planSubject.isCoreBadge = undefined;
        planSubject.hasExamBadge = undefined;
        dispatch(setUpdatePlanSubjectData(planSubject));
        navigate(routes.addSubjectPlanCourse);
    }

    const options = data?.items.map(() => [
        {
            label: 'Eliminar',
            onClick: (planSubject: PlanSubjectType) => handleDelete(planSubject)
        },
        {
            label: 'Gerir plano da disciplina',
            onClick: (planSubject: PlanSubjectType) => handleAddSubjectPlan(planSubject),
            icon: <TrashIcon />
        }
    ]) || [];


    return (
        <Lists
            status={status}
            TableComponent={()=>
                <TableComponent
                columns={Object.keys(columnNamesMap)}
                items={data?.items.map(i=>{return{
                    ...i,
                    isCoreBadge: i.isCore? <Badge color='green'>Nuclear</Badge>:<Badge color='gray'>Opcional</Badge>,
                    hasExameBadge: i.hasExam? <Badge color='green'>Sim</Badge>:<Badge color='red'>Não</Badge>
                }})}
                options={options}
                columnNamesMap={columnNamesMap}
                totalPages={data?.totalPages || 1}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                />
            }
            handleClickCreate={handleClickCreate}
            />
    );
}